





import { Component, Vue } from 'vue-property-decorator';
import { LHNJSSDKModuleMapper } from '@/store/modules/lhnJsSdk';
import { ConstantsModuleMapper } from '@/store/modules/constants';
import { ConfigsModuleMapper } from '@/store/modules/config';

import Icon from '@/components/common/icon.vue';

const Mappers = Vue.extend({
  computed: {
    ...ConfigsModuleMapper.mapGetters(['jurisdiction', 'punterHash']),
    ...ConstantsModuleMapper.mapGetters(['chat']),
    ...LHNJSSDKModuleMapper.mapGetters(['dictionary', 'setup', 'controls']),
  },
  methods: {
    ...LHNJSSDKModuleMapper.mapMutations(['updateAccessScriptError']),
  },
});

@Component({
  components: {
    Icon,
  },
})
export default class EnChatButtonComponent extends Mappers {
  openLhnChat() {
    try {
      (window as any).lhnJsSdk.openHOC('c');
    } catch (e) {
      this.updateAccessScriptError(true);
    }
    return false;
  }

  mounted() {
    let applicationConfig = this.setup.curacao.default as Record<string, string>;
    let applicationControls = this.controls.curacao.default as Record<string, string>;
    switch (this.jurisdiction) {
      case 'CURACAO': {
        applicationConfig = this.setup.curacao[this.setup.curacao[this.$i18n.locale] ? this.$i18n.locale : 'default'];
        applicationControls = this.controls.curacao[this.controls.curacao[this.$i18n.locale] ? this.$i18n.locale : 'default'];
        break;
      }
      case 'SPAIN': {
        applicationConfig = this.setup.spain.default;
        if (['es'].indexOf(this.$i18n.locale) !== -1) {
          applicationControls = this.controls.spain.default;
        } else {
          applicationControls = this.controls.spain.en;
        }
        break;
      }
      case 'ITALY': {
        applicationConfig = this.setup.italy.default;
        if (['it'].indexOf(this.$i18n.locale) !== -1) {
          applicationControls = this.controls.italy.default;
        } else {
          applicationControls = this.controls.italy.en;
        }
        break;
      }
      case 'DENMARK': {
        applicationConfig = this.setup.denmark.default;
        if (['da'].indexOf(this.$i18n.locale) !== -1) {
          applicationControls = this.controls.denmark.default;
        } else {
          applicationControls = this.controls.denmark.en;
        }
        break;
      }
      default: {
        break;
      }
    }

    /* eslint-disable func-names */
    (window as any).lhnJsSdkInit = () => {
      (window as any).lhnJsSdk.setup = applicationConfig;
      (window as any).lhnJsSdk.controls = [applicationControls];
      const dictionary = {} as Record<string, string>;
      Object
        .keys(this.dictionary)
        .forEach((item: string, index, array: string[]) => {
          dictionary[item] = this.$t(this.dictionary[item], this.$i18n.locale) as string;
        });
      (window as any).lhnJsSdk.dictionary = dictionary;
      if (this.punterHash) {
        (window as any).lhnJsSdk.options = {
          custom3: this.punterHash,
        };
      }
    };

    const lhnjs = document.getElementsByTagName('script')[0];
    const newjs = document.createElement('script');
    (newjs as any).src = 'https://developer.livehelpnow.net/js/sdk/lhn-jssdk-current.min.js';
    (lhnjs as any).parentNode.insertBefore(newjs, lhnjs);

    newjs.onerror = () => {
      this.updateAccessScriptError(true);
    };
  }
}
